module.exports = __webpack_public_path__ + "img/cooperation10.5d5d2ce7.png";